module.exports = __webpack_public_path__ + "img/jiankang.6d05470c.jpg";